const homeButtons = () => {
	return (
		<>
			<button className="home-buttons home-button--resume"><a rel="noreferrer" target="_blank" href="https://drive.google.com/file/d/1_btqUOzU95V1bUb30xse2OEMiw1e5aRy/view?usp=drive_linkhttps://drive.google.com/file/d/1_btqUOzU95V1bUb30xse2OEMiw1e5aRy/view?usp=drive_link">resume</a></button>
			<button className="home-buttons home-button--contact"><a href="mailto:developer@grantdarling.com">contact</a></button>
		</>
	)
}

export default homeButtons;